import React, { useState, useEffect } from "react";
import "./PrivacyStatement.css";

const PRIVACY_VERSION = "1.2.0";

function PrivacyStatement({ onAccept, onClose, readOnly = false, username = "", contactEmail = "" }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    document.getElementById("privacy-modal")?.focus();
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => setReady(true), 500);
    return () => { document.body.style.overflow = "unset"; clearTimeout(t); };
  }, []);

  const handleAccept = () => {
    // Store per-user privacy acceptance
    const key = username || "";
    localStorage.setItem(`privacyAccepted_${key}`, "true");
    localStorage.setItem(`privacyAcceptedVersion_${key}`, PRIVACY_VERSION);
    localStorage.setItem(`privacyAcceptedAt_${key}`, new Date().toISOString());
    onAccept();
  };

  return (
    <div className="priv-overlay" role="dialog" aria-modal="true" aria-labelledby="priv-title" onClick={readOnly ? onClose : undefined}>
      <div id="privacy-modal" className="priv-modal" tabIndex="-1" onClick={(e) => e.stopPropagation()}>

        <div className="priv-header">
          <h2 id="priv-title" className="priv-title">Welcome to ATC Gen AI Store</h2>
          <p className="priv-subtitle">
            Usage guidelines and policies for this digital resource designed to enhance productivity and collaboration.
          </p>
        </div>

        <div className="priv-body">
          <div className="priv-grid">

            <div className="priv-section">
              <h3 className="priv-heading">Monitoring & Compliance</h3>
              <ul>
                <li>Usage of this resource is subject to monitoring.</li>
                <li>You must follow all Accenture company policies and procedures, including the Accenture Responsible AI guidelines.</li>
                <li>Use of publicly available consumer Gen AI tools remains subject to relevant Accenture policies.</li>
              </ul>
            </div>

            <div className="priv-section">
              <h3 className="priv-heading">Accuracy & Verification</h3>
              <ul>
                <li>Responses from ATC Gen AI Store may be inaccurate. Always verify accuracy before acting on them.</li>
                <li>Third-party materials may be subject to copyright — ensure you have the necessary permissions.</li>
              </ul>
            </div>

            <div className="priv-section">
              <h3 className="priv-heading">Using Accenture Data</h3>
              <ul>
                <li>Your conversations, prompts, responses, and uploaded files are private and secure.</li>
                <li>The platform supports confidential data in accordance with Accenture Data Classification guidelines.</li>
                <li>Exercise best judgement when handling sensitive information — sharing remains at your discretion.</li>
              </ul>
            </div>

            <div className="priv-section">
              <h3 className="priv-heading">Using Personal Data</h3>
              <ul>
                <li>Use only the personal data needed to achieve your business objective.</li>
                <li>Avoid making automated decisions about individuals based solely on AI output.</li>
                <li>Use personal data in accordance with the privacy notice or consent provided by individuals.</li>
              </ul>
            </div>

            <div className="priv-section">
              <h3 className="priv-heading">Ethical Concerns</h3>
              <ul>
                <li>If you encounter an ethical concern such as biased AI output, report it immediately.</li>
                <li>Raise concerns through the Accenture Ethics & Compliance channel.</li>
              </ul>
            </div>

            <div className="priv-section">
              <h3 className="priv-heading">Questions & Contact</h3>
              <p>
                For questions or concerns, reach out to{" "}
                {contactEmail && (
                  <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                )}
              </p>
            </div>

          </div>

          {!readOnly && (
            <div className="priv-consent">
              By clicking "Agree & Continue", you acknowledge that you have read and agree to the
              guidelines and policies described above.
            </div>
          )}
        </div>

        <div className="priv-footer">
          <span className="priv-version">v{PRIVACY_VERSION}</span>
          <div className="priv-actions">
            {readOnly ? (
              <button className="priv-close-btn" onClick={onClose}>Close</button>
            ) : (
              <button
                className={`priv-accept-btn ${ready ? "ready" : ""}`}
                onClick={handleAccept}
                disabled={!ready}
              >
                Agree & Continue
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyStatement;
